import React, { Component } from 'react'
import '../App.css'
import Spinner from '../common/Spinner.js'
import { Button, Jumbotron } from 'react-bootstrap'

export default class LoginPage extends Component {
  render () {
    if (this.props.loading) {
      return (
        <div className='LoginPage'>
          <Spinner />
        </div>
      )
    } else {
      return (
        <div className='LoginPage'>
          <Jumbotron style={{background: 'none'}}>
            <h1>friXr</h1>
            <p>Dating powered by your Social Network: for your friends, by your friends.</p>
            <p><Button bsStyle='primary' bsSize='lg' onClick={this.props.onLoginClicked}>Login with Facebook</Button></p>
          </Jumbotron>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login.js